export enum QRErrorCorrectionLevel {
    L,
    M,
    Q,
    H
}